<template>
   <div class="row">
      <!-- pesquisa sentenciado -->
      <div id="search-nav" class="col-12 d-block btn-group dropup">
         <button type="button" class="btn btn-primary dropdown-toggle d-block d-lg-none rounded" :class="pesquisa.resultado.length > 0 ? '' : 'empty'" data-toggle="dropdown" aria-expanded="false">
            <i class="far fa-search font-17"></i>
         </button>
         <div class="card mb-2 dropdown-menu dropdown-menu-left">
            <div class="card-body pb-0">
               <div class="row m-0">
                  <div class="col-md-2 mb-3 px-1">
                     <label><i class="far fa-filter font-13 color-theme mr-1"></i> Tipo de pesquisa</label>
                     <v-select class="rounded" title="Desktop" :options="['Todos', 'Não finalizados', 'Finalizados', 'Em cumprimento', 'Descumprimento', 'Arquivado']" v-model="pesquisa.tipo" />
                     <select title="Mobile" class="form-control rounded" v-model="pesquisa.tipo">
                        <option v-for="(option, index) in ['Todos', 'Não finalizados', 'Finalizados', 'Em cumprimento', 'Descumprimento', 'Arquivado']" :key="index" :value="option">{{ option }}</option>
                     </select>
                  </div>
                  <div class="col-md-7 mb-3 px-1">
                     <label><i class="far fa-search font-13 color-theme mr-1"></i> Pesquisa</label>
                     <input type="text" class="form-control rounded" placeholder="Nome ou Nº do processo" v-model="pesquisa.valor" maxlength="200" @keyup.enter="buscarSentenciados(0)"/>
                  </div>
                  <div class="col-5 col-sm-6 col-md-1 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="buscarSentenciados(0)">
                        <i class="fa fa-search font-13"></i>
                     </button>
                  </div>
                  <div class="col-7 col-sm-6 col-md-2 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="adicionarSentenciado()">
                        <i class="fa fa-plus font-13 mr-1"></i> Adicionar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <!-- cards sentenciado -->
      <div class="col-12" v-if="pesquisa.resultado.length > 0">
			<div class="card mb-0">
				<div class="card-body">
					<div class="row px-1">
						<div class="col mb-2 align-self-center">
							<div class="limitador-1 mb-1"><i class="fas fa-angle-right color-theme me-1"></i> {{ totalPagina }} resultado(s) de {{ totalBanco }}</div>
						</div>
						<div class="w-max-content mb-2">
							<a href="javascript:;" class="badge badge-default bg-theme mb-1 p-2" @click="mudarVisao()"><i class="fas fa-exchange-alt font-10 mr-1"></i> {{ modoVisao == 'visaoSimples' ? 'Visão detalhada' : 'Visão simples' }}</a>
							<a href="javascript:;" class="badge badge-default bg-theme mb-1 p-2" @click="abrirRelatorioGeral()"><i class="far fa-file-alt font-10 mr-1"></i> Relatório</a>
						</div>
					</div>
               <div class="cards-3">
                  <sentenciado v-for="(sentenciado, index) in pesquisa.resultado" :key="index" :sentenciado="sentenciado" :modoVisao="modoVisao" :index="index" @editar="editarSentenciado($event)" @excluir="deletarSentenciado($event)" @imprimir="imprimirRelatorio($event)"/>
               </div>
				</div>
			</div>
      </div>
      <div class="col-12 my-5 text-center" v-else>Nenhum resultado encontrado</div>

      <!-- ver mais -->
      <div class="col-12">
         <div class="d-flex justify-content-center my-4" v-if="totalPagina == 50">
            <button class="btn btn-primary rounded" title="Carregar mais" @click="buscarSentenciados(null)">
               <span><i class="fal fa-sync-alt mr-2"></i>Carregar mais</span>
            </button>
         </div>
      </div>

      <!-- modal sentenciado -->
      <div class="modal fade" id="modalSentenciado" tabindex="-1" data-backdrop="static" aria-labelledby="modalSentenciadoLabel" aria-hidden="true">
         <div class="modal-dialog modal-xxl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content h-100">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalSentenciadoLabel" v-if="modal != null && modal.id != null">Editar sentenciado</h5>
                  <h5 class="modal-title h4" id="modalSentenciadoLabel" v-else>Adicionar sentenciado</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body" v-if="modal != null">
                  <div class="card mb-2">
                     <div class="card-body py-3" id="add_sentenciado_step1">
                        <ul class="nav nav-tabs3 overflow">
                           <li class="nav-item"><a class="nav-link active text-uppercase fw-bold" data-toggle="tab" href="#dadospessoais"><i class="far fa-id-card mr-1"></i>Dados pessoais</a></li>
                           <li class="nav-item"><a class="nav-link text-uppercase fw-bold" data-toggle="tab" href="#processo"><i class="far fa-file-alt mr-1"></i>Processo</a></li>
                           <li class="nav-item"><a class="nav-link text-uppercase fw-bold" data-toggle="tab" href="#entidade"><i class="far fa-graduation-cap mr-1"></i>Entidade</a></li>
                           <li class="nav-item"><a class="nav-link text-uppercase fw-bold" data-toggle="tab" href="#sentencas" v-if="modal.id != null"><i class="far fa-gavel mr-1"></i>Relatórios</a></li>
                           <li class="nav-item"><a class="nav-link text-uppercase fw-bold" data-toggle="tab" href="#arquivos"><i class="far fa-folder mr-1"></i>Arquivos</a></li>
                        </ul>
                     </div>
                  </div>
                  <div class="tab-content padding-0 mt-0">

                     <!-- dados pessoais -->
                     <div class="tab-pane active" id="dadospessoais">
                        <div class="card mb-2">
                           <div class="card-body py-3" id="add_sentenciado_step2">
                              <div class="row">
                                 <div class="col-12">
                                    <h6 class="mb-3 text-uppercase fw-bold">Dados de Identificação Básica</h6>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-user color-theme font-13 mr-1"></i> Nome completo <span class="text-danger" v-show="modal.nomeCompleto == null || modal.nomeCompleto == ''">*</span></label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.nomeCompleto" />
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-calendar color-theme font-13 mr-1"></i> Data de nascimento</label>
                                    <input type="text" class="form-control rounded" v-model="modal.dataNascimento" v-mask="'##/##/####'" />
                                 </div>
                                 <div class="col-xl-2 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-address-card color-theme font-13 mr-1"></i> Tipo de Documento </label>
                                    <v-select class="rounded" title="Desktop" :options="['CPF', 'RG', 'Outros']" v-model="modal.tipoDocumento" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.tipoDocumento">
                                       <option v-for="(option, index) in ['CPF', 'RG', 'Outros']" :key="index" :value="option">{{ option }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-4 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-id-card-alt color-theme font-13 mr-1"></i> Nº Documento de Identificação </label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.identificacao" v-mask="modal.tipoDocumento === 'CPF' ? '###.###.###-##' : modal.tipoDocumento === 'RG' ? 'XXXXXXXXXXX' : '####################'" />
                                 </div>
                                 <div class="col-xl-3 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-venus-mars color-theme font-13 mr-1"></i> Sexo <span class="text-danger" v-show="modal.sexo == null || modal.sexo == ''">*</span></label>
                                    <v-select class="rounded" title="Desktop" :options="['Masculino', 'Feminino', 'Outros', 'Preferir não informar']" v-model="modal.sexo" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.sexo">
                                       <option v-for="(option, index) in ['Masculino', 'Feminino', 'Outros', 'Preferir não informar']" :key="index" :value="option">{{ option }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-3 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-walking color-theme font-13 mr-1"></i> Raça </label>
                                    <v-select class="rounded" title="Desktop" :options="['Branco', 'Preto', 'Pardo', 'Amarelo', 'Indígena']" v-model="modal.raca" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.raca">
                                       <option v-for="(option, index) in ['Branco', 'Preto', 'Pardo', 'Amarelo', 'Indígena']" :key="index" :value="option">{{ option }}</option>
                                    </select>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="card mb-2">
                           <div class="card-body py-3">
                              <div class="row">
                                 <div class="col-12">
                                    <h6 class="mb-3 text-uppercase fw-bold">Contato e Localização</h6>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-phone-alt color-theme font-13 mr-1"></i> Número de telefone</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.telefone" v-mask="'+## ## #####-####'" />
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <div class="row m-0">
                                       <div class="col-9 pl-0 pr-1">
                                          <label class="mb-1"><i class="far fa-map-marker color-theme font-13 mr-1"></i> CEP</label>
                                          <input type="text" class="form-control rounded" v-mask="'#####-###'" v-model="modal.cep" @keyup.enter="buscarCEP()" />
                                       </div>
                                       <div class="col-3 pl-1 pr-0 align-self-end">
                                          <button class="btn btn-primary w-100 rounded" @click="buscarCEP()">
                                             <i class="far fa-search mr-2"></i>Buscar
                                          </button>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-xl-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-map-marker color-theme font-13 mr-1"></i> Endereço</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.endereco" />
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="card mb-2">
                           <div class="card-body py-3">
                              <div class="row">
                                 <div class="col-12">
                                    <h6 class="mb-3 text-uppercase fw-bold">Situação Socioeconômica</h6>
                                 </div>
                                 <div class="col-xl-4 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-heart color-theme font-13 mr-1"></i> Renda familiar</label>
                                    <input type="text" class="form-control rounded" v-mask="['#.##', '##.##', '###.##', '####.##', '#####.##', '######.##']"  v-model="modal.rendaFamiliar" />
                                 </div>
                                 <div class="col-xl-4 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-users-medical color-theme font-13 mr-1"></i> Nº residentes na casa</label>
                                    <input type="text" class="form-control rounded" v-mask="'###############'" v-model="modal.numeroResidentes" />
                                 </div>
                                 <div class="col-xl-4 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-users-medical color-theme font-13 mr-1"></i> Nº de crianças?</label>
                                    <input type="text" class="form-control rounded" v-mask="'###############'" v-model="modal.numeroResidentesCriancas" />
                                 </div>
                                 <div class="col-xl-4 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-users-medical color-theme font-13 mr-1"></i> Nº de idosos</label>
                                    <input type="text" class="form-control rounded" v-mask="'###############'" v-model="modal.numeroResidentesIdosos" />
                                 </div>
                                 <div class="col-xl-4 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-users-medical color-theme font-13 mr-1"></i> Nº que frequentam a escola?</label>
                                    <input type="text" class="form-control rounded" v-mask="'###############'" v-model="modal.numeroCriancasEscola" />
                                 </div>
                                 <div class="col-xl-4 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-users-medical color-theme font-13 mr-1"></i> Nº com remuneração salarial?</label>
                                    <input type="text" class="form-control rounded" v-mask="'###############'" v-model="modal.numeroResidentesRemuneracao" />
                                 </div>
                                 <div class="col-xl-12 px-1">
                                    <label class="mb-1"><i class="far fa-stethoscope color-theme font-13 mr-1"></i> Recebe algum tipo de benefício do governo?</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.beneficiosRecebidos" />
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="card mb-2">
                           <div class="card-body py-3">
                              <div class="row">
                                 <div class="col-12">
                                    <h6 class="mb-3 text-uppercase fw-bold">Saúde e Vulnerabilidades</h6>
                                 </div>
                                 <div class="col-xl-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-heart color-theme font-13 mr-1"></i> Problemas de saúde?</label>
                                    <v-select class="rounded" title="Desktop" :options="[{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" label="desc" v-model="modal.problemasSaude"  />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.problemasSaude">
                                       <option v-for="(option, index) in [{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" :key="index" :value="option">{{ option.desc }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-12 px-1 mb-3" v-if="modal.problemasSaude != null && modal.problemasSaude.value == true">
                                    <label class="mb-1"><i class="far fa-heart color-theme font-13 mr-1"></i> Saúde (Especifique)</label>
                                    <textarea class="form-control rounded" v-model="modal.descricaoProblema"></textarea>
                                 </div>
                                 <div class="col-xl-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-wheelchair color-theme font-13 mr-1"></i> Deficiências?</label>
                                    <v-select class="rounded" title="Desktop" :options="[{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" label="desc" v-model="modal.deficiente" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.deficiente">
                                       <option v-for="(option, index) in [{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" :key="index" :value="option">{{ option.desc }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-12 px-1 mb-3" v-if="modal.deficiente != null && modal.deficiente.value == true">
                                    <label class="mb-1"><i class="far fa-wheelchair color-theme font-13 mr-1"></i> Deficiência (Especifique)</label>
                                    <textarea class="form-control rounded" v-model="modal.deficiencia"></textarea>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-users-medical color-theme font-13 mr-1"></i> Doenças na família?</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.doencasFamilia" />
                                 </div>
                                 <div class="col-xl-6 px-1">
                                    <label class="mb-1"><i class="far fa-tablets color-theme font-13 mr-1"></i> Medicamentos contínuos?</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.medicamentosContinuos" />
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="card mb-2">
                           <div class="card-body py-3">
                              <div class="row">
                                 <div class="col-12">
                                    <h6 class="mb-3 text-uppercase fw-bold">Educação e Trabalho</h6>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-user-graduate color-theme font-13 mr-1"></i> Estuda?</label>
                                    <v-select class="rounded" title="Desktop" :options="[{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" label="desc" v-model="modal.estudante" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.estudante">
                                       <option v-for="(option, index) in [{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" :key="index" :value="option">{{ option.desc }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-user-graduate color-theme font-13 mr-1"></i> Escolaridade</label>
                                    <v-select class="rounded" title="Desktop" :options="['Ensino fundamental incompleto', 'Ensino fundamental completo', 'Ensino médio incompleto', 'Ensino médio completo', 'Ensino superior incompleto', 'Ensino superior completo']" v-model="modal.grauEscolaridade" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.grauEscolaridade">
                                       <option v-for="(option, index) in ['Ensino fundamental incompleto', 'Ensino fundamental completo', 'Ensino médio incompleto', 'Ensino médio completo', 'Ensino superior incompleto', 'Ensino superior completo']" :key="index" :value="option">{{ option }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-6 px-1">
                                    <label class="mb-1"><i class="far fa-graduation-cap color-theme font-13 mr-1"></i> Interesse em estudar?</label>
                                    <v-select class="rounded" title="Desktop" :options="[{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" label="desc" v-model="modal.interesseEstudar" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.interesseEstudar">
                                       <option v-for="(option, index) in [{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" :key="index" :value="option">{{ option.desc }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-star color-theme font-13 mr-1"></i> Habilidades</label>
                                    <input type="text" class="form-control rounded shadow-none" maxlength="250" v-model="modal.habilidades"/>
                                 </div>
                                 <div class="col-xl-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-suitcase color-theme font-13 mr-1"></i> Trabalha?</label>
                                    <v-select class="rounded" title="Desktop" :options="[{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" label="desc" v-model="modal.trabalhando" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.trabalhando">
                                       <option v-for="(option, index) in [{'value': true, 'desc': 'Sim'}, {'value': false, 'desc': 'Não'}]" :key="index" :value="option">{{ option.desc }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3" v-if="modal.trabalhando != null && modal.trabalhando.value == true">
                                    <label class="mb-1"><i class="far fa-user-hard-hat color-theme font-13 mr-1"></i> Profissão</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.profissao" />
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3" v-if="modal.trabalhando != null && modal.trabalhando.value == true">
                                    <label class="mb-1"><i class="far fa-building color-theme font-13 mr-1"></i> Local de trabalho</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.localTrabalho" />
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3" v-if="modal.trabalhando != null && modal.trabalhando.value == true">
                                    <label class="mb-1"><i class="far fa-moon color-theme font-13 mr-1"></i> Turno</label>
                                    <v-select class="rounded" title="Desktop" :options="['Manhã', 'Tarde', 'Noite']" v-model="modal.turnoTrabalho" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.turnoTrabalho">
                                       <option v-for="(option, index) in ['Manhã', 'Tarde', 'Noite']" :key="index" :value="option">{{ option }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-6 px-1" v-if="modal.trabalhando != null && modal.trabalhando.value == true">
                                    <label class="mb-1"><i class="far fa-map-marker color-theme font-13 mr-1"></i> Endereço</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.enderecoTrabalho" />
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="card mb-2">
                           <div class="card-body py-3">
                              <div class="row">
                                 <div class="col-12">
                                    <h6 class="mb-3 text-uppercase fw-bold">Família</h6>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-female color-theme font-13 mr-1"></i> Nome mãe</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.nomeMae" />
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-male color-theme font-13 mr-1"></i> Nome pai</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.nomePai" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <!-- processo -->
                     <div class="tab-pane" id="processo">
                        <div class="card mb-2">
                           <div class="card-body py-3">
                              <div class="row">
                                 <div class="col-12">
                                    <h6 class="mb-3 text-uppercase fw-bold">Dados do processo</h6>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-hashtag color-theme font-13 mr-1"></i> Nº do processo <span class="text-danger" v-show="modal.numeroProcesso == null || modal.numeroProcesso == ''">*</span></label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.numeroProcesso"/>
                                 </div>
                                 <div class="col-xl-3 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-clock color-theme font-13 mr-1"></i> Total de horas <span class="text-danger" v-show="tratado.horas == null || tratado.horas == ''">*</span></label>
                                    <input type="text" class="form-control rounded" v-mask="'###############'" v-model="tratado.horas" :disabled="modal.id != null"/>
                                 </div>
                                 <div class="col-xl-3 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-clock color-theme font-13 mr-1"></i> Minutos <span class="text-danger" v-show="tratado.minutos == null || tratado.minutos == ''">*</span></label>
                                    <input type="text" class="form-control rounded" v-mask="'##'" v-model="tratado.minutos" :disabled="modal.id != null"/>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-building color-theme font-13 mr-1"></i> Local</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.localProcesso" />
                                 </div>
                                 <div class="col-xl-3 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-balance-scale-left color-theme font-13 mr-1"></i> Vara de origem</label>
                                    <v-select class="rounded" title="Desktop" :options="['CRIMINAL', 'JECRIM']" v-model="modal.varaOrigem" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.varaOrigem">
                                       <option v-for="(option, index) in ['CRIMINAL', 'JECRIM']" :key="index" :value="option">{{ option }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-3 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-circle color-theme font-13 mr-1"></i> Status</label>
                                    <v-select class="rounded" title="Desktop" :options="['Em cumprimento', 'Descumprimento', 'Arquivado']" v-model="modal.status" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.status">
                                       <option v-for="(option, index) in ['Em cumprimento', 'Descumprimento', 'Arquivado']" :key="index" :value="option">{{ option }}</option>
                                    </select>
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-balance-scale color-theme font-13 mr-1"></i> Artigo(s)</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.artigo" />
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-stream color-theme font-13 mr-1"></i> Tipo de delito</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.tipoDelito" />
                                 </div>
                                 <div class="col-xl-6 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-calendar color-theme font-13 mr-1"></i> Data do delito</label>
                                    <input type="text" class="form-control rounded" v-model="modal.dataDelito" v-mask="'##/##/####'" />
                                 </div>
                                 <div class="col-xl-3 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-folder color-theme font-13 mr-1"></i> Nº da Pasta</label>
                                    <input type="text" class="form-control rounded" v-mask="'###############'" v-model="modal.numeroPasta" />
                                 </div>
                                 <div class="col-xl-3 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-calendar color-theme font-13 mr-1"></i> Data de encaminhamento</label>
                                    <input type="text" class="form-control rounded" v-model="modal.encaminhamento" v-mask="'##/##/####'" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <!-- entidade vinculada -->
                     <div class="tab-pane" id="entidade">
                        <div class="card mb-2">
                           <div class="card-body p-3">
                              <div class="row m-0">
                                 <div class="col-sm-10 mb-2 px-1">
                                    <label><i class="far fa-building font-13 color-theme mr-1"></i> Nome da entidade</label>
                                    <input type="text" class="form-control rounded" v-model="pesquisa.nomeEntidade" maxlength="200" @keyup.enter="buscarEntidades(0)" />
                                 </div>
                                 <div class="col-sm-2 mb-2 px-1 align-self-end">
                                    <button type="button" class="btn btn-primary w-100 rounded" @click="buscarEntidades(0)">
                                       <i class="fa fa-search font-13"></i>
                                    </button>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-12" v-if="pesquisa.resultadoEntidades.length > 0">
                              <div class="cards">
                                 <div class="card mb-0 cursor-pointer" v-for="(entidade, index) in pesquisa.resultadoEntidades" :key="index" :class="entidade.id == modal.idEntidade ? 'border-success' :  ''" ref="entidade" @click="vincularEntidade(entidade)">
                                    <div class="card-body">
                                       <h5 class="card-title limitador">{{entidade.nome}}</h5>
                                       <div class="row">
                                          <div class="col-md-12">
                                             <p><strong>CNPJ:</strong> {{entidade.cnpj}}</p>
                                             <p><strong>Telefone:</strong> {{entidade.telefone}}</p>
                                             <p class="limitador-2"><strong>Endereço:</strong> {{entidade.endereco}}</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div> 
                              </div>
                           </div>
                           <div class="col-12 my-5 text-center" v-else>Nenhum resultado encontrado</div>

                           <!-- ver mais das entidades-->
                           <div class="col-12">
                              <div class="d-flex justify-content-center my-4" v-if="totalPagina2 == 50">
                                 <button class="btn btn-primary rounded" title="Carregar mais" @click="buscarEntidades(null)">
                                    <span><i class="fal fa-sync-alt mr-2"></i>Carregar mais</span>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>

                     <!-- relatórios -->
                     <div class="tab-pane" id="sentencas">
                        <div class="card mb-2">
                           <div class="card-body p-3">
                              <div class="row d-flex justify-content-between m-0">
                                 <div class="col-md-3 mb-2 px-1">
                                    <div class="d-flex flex-column">
                                       <div class="mb-2">
                                          <h6 class="mb-1">{{pesquisa.resultadoSentencas.length != 0 ? pesquisa.resultadoSentencas.length : 'Nenhum'}} {{pesquisa.resultadoSentencas.length > 1 ? 'registros' : 'registro'}}</h6>
                                       </div>
                                       <div class="progress" style="height: 15px">
                                          <div class="progress-bar bg-success font-12" 
                                             :style="{width: (modal.totalHoras - modal.horasPendentes)/modal.totalHoras*100 + '%'}"
                                             :title="formatarMinutosParaHoras(modal.totalHoras - modal.horasPendentes) + ' cumpridas'">
                                             {{((modal.totalHoras - modal.horasPendentes)/modal.totalHoras*100) >= 25 ? formatarMinutosParaHoras(modal.totalHoras - modal.horasPendentes) : formatarMinutosParaHoras(modal.totalHoras - modal.horasPendentes)}}
                                          </div>
                                          <div class="progress-bar bg-warning font-12"
                                             :style="{width: modal.horasPendentes/modal.totalHoras*100 + '%'}"
                                             :title="formatarMinutosParaHoras(modal.horasPendentes) + ' pendentes'">
                                             {{((modal.totalHoras - modal.horasPendentes)/modal.totalHoras*100) >= 75 ? formatarMinutosParaHoras(modal.horasPendentes) : formatarMinutosParaHoras(modal.horasPendentes)}}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-md-2 mb-2 px-1 align-self-center" v-if="modal.horasPendentes != 0">
                                    <button type="button" class="btn btn-primary w-100 rounded" @click="adicionarSentenca()">
                                       <i class="fa fa-plus font-13 mr-1"></i> Adicionar
                                    </button>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-12" v-if="pesquisa.resultadoSentencas.length > 0">
                              <div class="cards">
                                 <div class="card mb-0" v-for="(sentenca, index) in pesquisa.resultadoSentencas" :key="index">
                                    <div class="card-body py-2">
                                       <div class="d-flex justify-content-between align-items-center mb-1">
                                          <h4 class="card-title mb-0">{{Math.floor(sentenca.horasCumpridas/60).toString().padStart(2,'0')}}:{{(sentenca.horasCumpridas%60).toString().padStart(2,'0')}}</h4>
                                          <button type="button" class="btn btn-link p-0" @click="deletarSentenca(sentenca, index)">
                                             <i class="far fa-trash-alt text-danger"></i>
                                          </button>
                                       </div>
                                       <p class="text-muted mb-0 limitador"><i class="fas fa-school mr-1"></i>{{sentenca.nomeEntidade}}</p>
                                       <p class="text-muted mb-0"><i class="far fa-calendar-alt mr-1"></i>{{sentenca.data}}</p>
                                       <p class="text-muted mb-0 limitador" :title="sentenca.descricao"><i class="far fa-sticky-note mr-1"></i>{{sentenca.descricao || 'Sem descricao'}}</p>
                                       <button v-if="sentenca.anexos && sentenca.anexos[0]" type="button" class="btn color-theme p-0" @click="visualizarFile(sentenca.anexos[0])">
                                          <i class="fas fa-eye mr-1"></i> Visualizar arquivo
                                       </button>
                                       <button v-else type="button" class="btn color-theme p-0" disabled style="opacity: 0.5">
                                          <i class="fas fa-eye-slash mr-1"></i> Sem arquivo
                                       </button>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12 my-5 text-center" v-else>Nenhum resultado encontrado</div>
                        </div>
                     </div>

                     <!-- arquivos -->
                     <div class="tab-pane" id="arquivos">
                        <div class="cards-1">
                           <div v-if="modal.anexos.length < 100" class="card card-mini border border-dashed cursor-pointer mb-0">
                              <div class="card-body text-center py-5">
                                 <i class="far fa-cloud-upload fa-3x mb-3 text-muted"></i>
                                 <h6 class="mb-2 text-muted">Arraste e solte arquivos aqui</h6>
                                 <p class="mb-0 text-muted font-12">ou clique para selecionar arquivos</p>
                                 <input type="file" ref="files" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip,.rar" @change="showFiles()" multiple style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer;"/>
                              </div>
                           </div>
                           <div v-for="(file, index) in modal.anexos" :key="index" class="card mb-0">
                              <div class="card-body text-center">
                                 <i class="far fa-4x mb-3" :class="[file.name ? (file.name.match(/\.(jpg|jpeg|png|gif)$/i) ? 'fa-image' : 'fa-file') : (file.nome.match(/\.(jpg|jpeg|png|gif)$/i) ? 'fa-image' : 'fa-file')]"></i>
                                 <h6 class="limitador mt-0 mb-2">{{ file.name == null ? file.nome : file.name }}</h6>
                                 <span class="limitador d-block mb-3">
                                    <span class="text-secondary">{{ (file.size / 1048576) >= 1 ? (file.size / 1048576).toFixed(1) +"MB" : (file.size / 1024).toFixed(1) +"KB" }}</span>
                                 </span>
                                 <button type="button" class="btn btn-default btn-sm px-3 mr-1" @click="visualizarFile(file)" v-if="file.name == null && file.caminho != null">
                                    <span><i class="far fa-eye" :class="view ? 'mr-md-2' : ''"></i><span class="hidden-md" v-if="view">Visualizar</span></span>
                                 </button>
                                 <button type="button" class="btn btn-default btn-sm px-3" @click="removeFile(index, 'arquivos')" v-if="!view">
                                    <span><i class="far fa-trash" :class="file.name != null && file.caminho == null ? 'mr-md-2' : ''"></i><span class="hidden-md" v-if="file.name != null && file.caminho == null">Deletar</span></span>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-body my-5 text-center font-16" v-else>Nenhuma informação encontrada</div>
               <div class="modal-footer">
                  <button id="add_sentenciado_step3" type="button" class="btn btn-round btn-primary" @click="salvarSentenciado()">Salvar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <!-- modal sentencas -->
      <div class="modal fade" id="modalSentencas" tabindex="-1" data-backdrop="static" aria-labelledby="modalSentencasLabel" aria-hidden="true">
         <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalSentencaLabel">Adicionar sentença</h5>
                  <button type="button" class="close" aria-label="Close" data-dismiss="modal" data-toggle="modal" data-target="#modalSentenciado">
                     <span aria-hidden="true">×</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="card mb-0">
                     <div class="card-body">
                        <div class="row m-0">
                           <div class="col-xl-3 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-clock color-theme font-13 mr-1"></i> Horas *</label>
                              <input type="text" class="form-control rounded" v-mask="'###############'" v-model="tratado2.horas"/>
                           </div>
                           <div class="col-xl-3 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-clock color-theme font-13 mr-1"></i> Minutos *</label>
                              <input type="text" class="form-control rounded" v-mask="'##'" v-model="tratado2.minutos"/>
                           </div>
                           <div class="col-xl-6 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-calendar color-theme font-13 mr-1"></i> Data *</label>
                              <input type="text" class="form-control rounded" v-model="modalSentencas.data" v-mask="'##/##/####'" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-ellipsis-h color-theme font-13 mr-1"></i> Descrição</label>
                              <textarea type="text" class="form-control rounded shadow-none" maxlength="250" v-model="modalSentencas.descricao"></textarea>
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-paperclip color-theme font-13 mr-1"></i> Anexo</label>
                              <div class="h-100">
                                 <div class="card mb-0 position-relative" style="border: 2px dashed #303338; cursor: pointer;" v-if="modalSentencas.anexos.length < 1">
                                    <div class="card-body text-center py-5">
                                       <i class="far fa-cloud-upload fa-3x mb-3 text-muted"></i>
                                       <h6 class="mb-2 text-muted">Arraste e solte arquivos aqui</h6>
                                       <p class="mb-0 text-muted font-12">ou clique para selecionar arquivos</p>
                                       <input class="h-100 input-full" type="file" ref="files2" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip,.rar" @change="showFiles2()" style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer;"/>
                                    </div>
                                 </div>
                                 
                                 <div v-for="(file, index) in modalSentencas.anexos" :key="index" class="card mb-0">
                                    <div class="card-body text-center">
                                       <i class="far fa-4x mb-3" :class="[file.name ? (file.name.match(/\.(jpg|jpeg|png|gif)$/i) ? 'fa-image' : 'fa-file') : (file.nome.match(/\.(jpg|jpeg|png|gif)$/i) ? 'fa-image' : 'fa-file')]"></i>
                                       <h6 class="limitador mt-0 mb-2">{{ file.name == null ? file.nome : file.name }}</h6>
                                       <span class="limitador d-block mb-3">
                                          <span class="text-secondary">{{ (file.size / 1048576) >= 1 ? (file.size / 1048576).toFixed(1) +"MB" : (file.size / 1024).toFixed(1) +"KB" }}</span>
                                       </span>
                                       <button type="button" class="btn btn-default btn-sm px-3 mr-1" @click="visualizarFile(file)" v-if="file.name == null && file.caminho != null">
                                          <span><i class="far fa-eye" :class="view ? 'mr-md-2' : ''"></i><span class="hidden-md" v-if="view">Visualizar</span></span>
                                       </button>
                                       <button type="button" class="btn btn-default btn-sm px-3" @click="removeFile(index, 'relatorios')" v-if="!view">
                                          <span><i class="far fa-trash" :class="file.name != null && file.caminho == null ? 'mr-md-2' : ''"></i><span class="hidden-md" v-if="file.name != null && file.caminho == null">Deletar</span></span>
                                       </button>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-primary" @click="salvarSentenca()">Salvar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal" data-toggle="modal" data-target="#modalSentenciado">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <!-- modal relatorio geral -->
      <div class="modal fade" id="modalRelatorioGeral" tabindex="-1" data-backdrop="static" aria-labelledby="modalRelatorioGeralLabel" aria-hidden="true">
         <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content h-75">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalSentencaLabel">Opções de relatório</h5>
                  <button type="button" class="close" aria-label="Close" data-dismiss="modal" data-toggle="modal">
                     <span aria-hidden="true">×</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="card mb-2">
                     <div class="card-body">
                        <div class="row m-0">
                           <div class="col-12 mb-3 px-1">
                              <h4 class="mb-2">Relatório de Sentenciados</h4>
                              <p class="text-muted mb-0">
                                 Gere um relatório completo dos sentenciados cadastrados no sistema. 
                                 Você pode filtrar os dados por sexo (Masculino, Feminino, Outros), 
                                 por vara de origem (CRIMINAL, JECRIM) e por status 
                                 (Em cumprimento, Descumprimento, Finalizado, Arquivado) para obter informações específicas.
                                 Este relatório fornecerá uma visão detalhada dos dados dos sentenciados 
                                 de acordo com os filtros selecionados.
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="card mb-0">
                     <div class="card-body">
                        <div class="row m-0">
                           <div class="col-xl-4 px-1">
                              <label class="mb-1"><i class="far fa-venus-mars color-theme font-13 mr-1"></i> Sexo <span class="text-danger" v-show="modalRelatorio.sexo == null || modalRelatorio.sexo == ''">*</span></label>
                              <v-select class="rounded" title="Desktop" :options="['Masculino', 'Feminino', 'Outros', 'Preferir não informar', 'Todos']" v-model="modalRelatorio.sexo" />
                              <select title="Mobile" class="form-control rounded" v-model="modalRelatorio.sexo">
                                 <option v-for="(option, index) in ['Masculino', 'Feminino', 'Outros', 'Preferir não informar', 'Todos']" :key="index" :value="option">{{ option }}</option>
                              </select>
                           </div>
                           <div class="col-xl-4 px-1">
                              <label class="mb-1"><i class="far fa-balance-scale-left color-theme font-13 mr-1"></i> Vara de origem <span class="text-danger" v-show="modalRelatorio.varaOrigem == null || modalRelatorio.varaOrigem == ''">*</span></label>
                              <v-select class="rounded" title="Desktop" :options="['CRIMINAL', 'JECRIM', 'Todos']" v-model="modalRelatorio.varaOrigem" />
                              <select title="Mobile" class="form-control rounded" v-model="modalRelatorio.varaOrigem">
                                 <option v-for="(option, index) in ['CRIMINAL', 'JECRIM', 'Todos']" :key="index" :value="option">{{ option }}</option>
                              </select>
                           </div>
                           <div class="col-xl-4 px-1">
                              <label class="mb-1"><i class="fas fa-spinner color-theme font-13 mr-1"></i> Status<span class="text-danger" v-show="modalRelatorio.filtro == null || modalRelatorio.filtro == ''">*</span></label>
                              <v-select class="rounded" title="Desktop" :options="['Em cumprimento', 'Descumprimento', 'Finalizado', 'Não finalizado', 'Arquivado', 'Todos']" v-model="modalRelatorio.filtro" />
                              <select title="Mobile" class="form-control rounded" v-model="modalRelatorio.filtro">
                                 <option v-for="(option, index) in ['Em cumprimento', 'Descumprimento', 'Finalizado', 'Não finalizado', 'Arquivado', 'Todos']" :key="index" :value="option">{{ option }}</option>
                              </select>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-primary" @click="gerarRelatorioGeral()">Gerar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal" data-toggle="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <!-- pdf -->
      <div class="col-12 d-none">
         <section ref="html2Pdf">
            <div class="pdf-container">
               <!-- Cabeçalho -->
               <div class="pdf-header">
                  <h1 class="pdf-title">RELATÓRIO DE SENTENCIADO</h1>
                  <div class="pdf-divider"></div>
               </div>

               <!-- Informações da Entidade -->
               <div class="pdf-section">
                  <h2 class="pdf-section-title">ENTIDADE</h2>
                  <div class="pdf-grid">
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Nome:</span>
                        <span class="pdf-value">{{ dadosPdf.nomeEntidade || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">CNPJ:</span>
                        <span class="pdf-value">{{ dadosPdf.cnpjEntidade || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item pdf-full-width">
                        <span class="pdf-label">Endereço:</span>
                        <span class="pdf-value">{{ dadosPdf.enderecoEntidade || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Email:</span>
                        <span class="pdf-value">{{ dadosPdf.emailEntidade || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Telefone:</span>
                        <span class="pdf-value">{{ dadosPdf.telefoneEntidade || 'Não informado' }}</span>
                     </div>
                  </div>
               </div>

               <!-- Informações do Sentenciado -->
               <div class="pdf-section">
                  <h2 class="pdf-section-title">SENTENCIADO</h2>
                  <div class="pdf-grid">
                     <div class="pdf-grid-item pdf-full-width">
                        <span class="pdf-label">Nome Completo:</span>
                        <span class="pdf-value">{{ dadosPdf.nomeCompleto || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Documento:</span>
                        <span class="pdf-value">{{ dadosPdf.identificacao || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Data de Nascimento:</span>
                        <span class="pdf-value">{{ formatarDataObjeto(dadosPdf.dataNascimento) }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Nº Processo:</span>
                        <span class="pdf-value">{{ dadosPdf.numeroProcesso || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Nº Pasta:</span>
                        <span class="pdf-value">{{ dadosPdf.numeroPasta || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Nome da Mãe:</span>
                        <span class="pdf-value">{{ dadosPdf.nomeMae || 'Não informado' }}</span>
                     </div>
                     <div class="pdf-grid-item">
                        <span class="pdf-label">Nome do Pai:</span>
                        <span class="pdf-value">{{ dadosPdf.nomePai || 'Não informado' }}</span>
                     </div>
                  </div>
               </div>

               <!-- Estatísticas com Gráfico -->
               <div class="pdf-section pdf-section-stats">
                  <h2 class="pdf-section-title">ESTATÍSTICAS DE CUMPRIMENTO</h2>
                  <div class="pdf-stats-container">
                     <div class="pdf-stats-data">
                        <div class="pdf-stat-item">
                           <span class="pdf-stat-label">(A) Horas Cumpridas</span>
                           <span class="pdf-stat-value">{{ formatarMinutosParaHoras(dadosPdf.horasCumpridas || 0) }}</span>
                        </div>
                        <div class="pdf-stat-item">
                           <span class="pdf-stat-label">(B) Horas Pendentes</span>
                           <span class="pdf-stat-value">{{ formatarMinutosParaHoras(dadosPdf.horasPendentes || 0) }}</span>
                        </div>
                        <div class="pdf-stat-item">
                           <span class="pdf-stat-label">Total de Horas</span>
                           <span class="pdf-stat-value">{{ formatarMinutosParaHoras(dadosPdf.totalHoras || 0) }}</span>
                        </div>
                        <div class="pdf-stat-item pdf-stat-percentage">
                           <span class="pdf-stat-label">Percentual Cumprido</span>
                           <span class="pdf-stat-value">{{ dadosPdf.totalHoras ? ((dadosPdf.horasCumpridas / dadosPdf.totalHoras) * 100).toFixed(1) : '0' }}%</span>
                        </div>
                     </div>
                     <div class="pdf-chart-wrapper">
                        <highcharts class="pdf-chart" ref="chart" :options="chartPie"></highcharts>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </div>

      <!-- pdfRelatorioGeral -->
      <div class="col-12 d-none">
         <section ref="html2PdfGeral">
            <div class="pdf-relatorio-geral">
               <div v-if="pesquisa.resultadoRelatorioGeral.dados.length > 0">
                  <!-- Cabeçalho -->
                  <div class="pdf-relatorio-header">
                     <h1 class="pdf-relatorio-title">Relatório de Sentenciados</h1>
                     <div class="pdf-relatorio-meta">
                        <div class="pdf-relatorio-stats">
                           <span class="pdf-stat-badge">{{ pesquisa.resultadoRelatorioGeral.dados.length }} {{ pesquisa.resultadoRelatorioGeral.dados.length === 1 ? 'resultado' : 'resultados' }}</span>
                           <span class="pdf-stat-badge">{{ pesquisa.resultadoRelatorioGeral.totalEmCumprimento }} em cumprimento</span>
                           <span class="pdf-stat-badge">{{ pesquisa.resultadoRelatorioGeral.totalDescumprimento }} em descumprimento</span>
                           <span class="pdf-stat-badge">{{ pesquisa.resultadoRelatorioGeral.totalArquivado }} arquivados</span>
                           <span class="pdf-stat-badge">{{ pesquisa.resultadoRelatorioGeral.totalFinalizados }} finalizados</span>
                        </div>
                        <div class="pdf-relatorio-filters">
                           <span class="pdf-filter-item">Sexo: {{ modalRelatorio.sexo }}</span>
                           <span class="pdf-filter-item">Vara: {{ modalRelatorio.varaOrigem }}</span>
                           <span class="pdf-filter-item">Filtro: {{ modalRelatorio.filtro }}</span>
                        </div>
                     </div>
                  </div>

                  <!-- Lista de Sentenciados -->
                  <div class="pdf-relatorio-content">
                     <div v-for="(item, index) in pesquisa.resultadoRelatorioGeral.dados" :key="index" class="pdf-sentenciado-card">
                        <div class="pdf-sentenciado-header">
                           <div class="pdf-sentenciado-number">{{ index + 1 }}</div>
                           <div class="pdf-sentenciado-name">{{ item.nomeCompleto }}</div>
                           <div class="pdf-sentenciado-status" :class="'status-' + item.status.toLowerCase().replace(' ', '-')">
                              {{ item.status }}
                           </div>
                        </div>
                        <div class="pdf-sentenciado-body">
                           <div class="pdf-sentenciado-grid">
                              <div class="pdf-sentenciado-field">
                                 <span class="pdf-field-label">Entidade</span>
                                 <span class="pdf-field-value">{{ item.nomeEntidade }}</span>
                              </div>
                              <div class="pdf-sentenciado-field">
                                 <span class="pdf-field-label">Processo</span>
                                 <span class="pdf-field-value">{{ item.numeroProcesso }}</span>
                              </div>
                              <div class="pdf-sentenciado-field">
                                 <span class="pdf-field-label">Vara de Origem</span>
                                 <span class="pdf-field-value">{{ item.varaOrigem }}</span>
                              </div>
                              <div class="pdf-sentenciado-field">
                                 <span class="pdf-field-label">Sexo</span>
                                 <span class="pdf-field-value">{{ item.sexo }}</span>
                              </div>
                              <div class="pdf-sentenciado-field">
                                 <span class="pdf-field-label">Total de Horas</span>
                                 <span class="pdf-field-value pdf-field-hours">{{ formatarMinutosParaHoras(item.totalHoras) }}</span>
                              </div>
                              <div class="pdf-sentenciado-field">
                                 <span class="pdf-field-label">Horas Cumpridas</span>
                                 <span class="pdf-field-value pdf-field-hours">{{ formatarMinutosParaHoras(item.horasCumpridas) }}</span>
                              </div>
                              <div class="pdf-sentenciado-field">
                                 <span class="pdf-field-label">Horas Pendentes</span>
                                 <span class="pdf-field-value pdf-field-hours">{{ formatarMinutosParaHoras(item.horasPendentes) }}</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </div>
   </div>
</template>

<script>
import $ from 'jquery'
import vuePDF from 'html2pdf.js'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
import sentenciado from '@/components/sentenciados/Sentenciado.vue'

export default {
	name: 'Sentenciados',
   data: function () {
      return {
         pesquisa: {'nome': null, 'valor': '', 'nomeEntidade': null, 'nomeSentenca': null, 'tipo': 'Todos', 'resultado': [], 'resultadoEntidades': [], 'resultadoSentencas': [], 'resultadoRelatorioGeral': {'dados':[]}},
         modal: {'id': null, 'idEntidade': null, 'nomeCompleto': null, 'sexo': null, 'identificacao': null, 'tipoDocumento': 'Outros', 'raca': 'Pardo',
            'cep': null, 'endereco': null, 'telefone': null, 'nomeMae': null, 'nomePai': null, 'profissao': null, 'localTrabalho': null, 'grauEscolaridade': 'Ensino médio completo',
            'habilidades': null, 'turnoTrabalho': 'Manhã', 'enderecoTrabalho': null,'descricaoProblema': null, 'deficiencia': null, 'doencasFamilia': null, 'medicamentosContinuos': null,
            'beneficiosRecebidos': null, 'estudante': null, 'interesseEstudar': null, 'trabalhando': null, 
            'problemasSaude': null, 'deficiente': null, 'participaServicoCRAS': null, 'rendaFamiliar': null,
            'numeroResidentesRemuneracao': null, 'numeroCriancasEscola': null, 'numeroResidentesIdosos': null, 'numeroResidentesCriancas': null, 'numeroResidentes': null,
            'dataNascimento': new Date().toLocaleDateString(), 'numeroProcesso': null, 'negligencia': null, 'totalHoras': null, 'localProcesso': null, 'varaOrigem': 'CRIMINAL', 'status': 'Em cumprimento',
            'artigo': null, 'tipoDelito': null, 'dataDelito': new Date().toLocaleDateString(), 'numeroPasta': null, 'encaminhamento': null, 'dataUltMov': null, 'anexos': [], 'horasPendentes': null,
            'entidade': {}, 'cnpjEntidade': null, 'nomeEntidade': null
         },
         modalSentencas: {'id': null, 'idEntidade': null, 'idSentenciado': null, 'data': new Date().toLocaleDateString(), 'horasCumpridas': null, 'descricao': null, 'descricaoFeedback': null,
            'feedback': null, 'anexos': []
         },
         pagina: 0,
         totalPagina: 0,
         totalBanco: 0,
         pagina2: 0,
         totalPagina2: 0,
         modoVisao: localStorage.getItem('modoVisao') ? localStorage.getItem('modoVisao') : 'visaoSimples',
         modalRelatorio: {'varaOrigem': 'Todos', 'sexo': 'Todos', 'filtro': 'Todos'},
         tratado: {'horas': 0, 'minutos': 0},
         tratado2: {'horas': 0, 'minutos': 0},
         modalConfig: {'researched': false, 'entidade': false},
         entidadeSelecionada: null,
         view: false,
         listaEntidades: [],
         showFile: {'show': false, 'file': null, 'extensao': ''},
         dadosPdf: {'averageFeedback': 0,'dataNascimento': {'dayOfMonth': 0, 'monthValue': 0, 'year': 0}, 'dataUltMov': {'dayOfMonth': 0, 'monthValue': 0, 'year': 0}, 'dataSentenca': {'dayOfMonth': 0, 'monthValue': 0, 'year': 0}},
         chartPie: {
				chart: {
					type: 'pie',
					options3d: {
						enabled: false
					},
					backgroundColor: 'transparent',
					height: null,
					accessibility: {
						enabled: false
					},
					animation: false,
				},
            credits: {
               enabled: false
            },
				title: {
					text: undefined
				},
				xAxis: {
					categories: [],
				},
				series: [{
					name: "Horas",
					data: [],
					dataLabels: {
						enabled: true,
						distance: 15,
						style: {
							fontSize: '9pt',
							fontWeight: '500',
							color: '#000000',
							textOutline: 'none'
						},
						formatter: function() {
							// Mapeia os nomes para letras
							const letterMap = {
								'Horas já cumpridas': 'A',
								'Horas pendentes': 'B'
							};
							return letterMap[this.point.name] || '';
						}
					}
				}],
				plotOptions: {
					pie: {
						innerSize: '50%',
						size: '75%',
						colors: ['#2c2c2c', '#5c5c5c', '#8c8c8c'],
						borderWidth: 1,
						borderColor: '#ffffff',
						dataLabels: {
							enabled: true,
							distance: 15,
							style: {
								fontSize: '9pt',
								fontWeight: '500',
								color: '#000000',
								textOutline: 'none'
							},
							formatter: function() {
								// Mapeia os nomes para letras
								const letterMap = {
									'Total de horas': 'C',
									'Horas já cumpridas': 'A',
									'Horas pendentes': 'B'
								};
								return letterMap[this.point.name] || '';
							}
						},
						showInLegend: false
					},
				},
				legend: {
					enabled: false
				},
				tooltip: {
					enabled: false
				}
			},
      }
   },
   computed: {
      ... mapState({
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   components: {
      sentenciado
   },
   methods: {
      buscarSentenciados(pagina) {
         let ref = this;
         this.pagina = pagina == null ? ++this.pagina : pagina

         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'sentenciado/getSentenciados',
            params: {
               tipo: this.pesquisa.tipo,
               valor: this.pesquisa.valor,
               page: this.pagina
            }
         }).then(response => {
            if (this.pagina == 0) {
               this.pesquisa.resultado = []
            }

            this.totalPagina = response.data.sentenciados.length
            this.totalBanco = response.data.totalSentenciados

            response.data.sentenciados.forEach(p => {
               this.pesquisa.resultado.push(p)
            });

            if (localStorage.getItem('tour_card_sentenciado') !== 'ok' && this.pesquisa.resultado.length > 0) {
               setTimeout(() => {
                  // this.startTour2()
               }, 500)
            }

            this.searchAllEntidades()

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      editarSentenciado(sentenciado) {
         let ref = this;

         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'sentenciado/getSentenciadoById',
            params: {
               id: sentenciado.id
            }
         }).then(response => {
            this.modal = JSON.parse(JSON.stringify(response.data))
            this.modal.encaminhamento = response.data.encaminhamento ? new Date(response.data.encaminhamento.year +'/'+ response.data.encaminhamento.monthValue +'/'+ response.data.encaminhamento.dayOfMonth).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : null;
				this.modal.dataNascimento = response.data.dataNascimento ? new Date(response.data.dataNascimento.year +'/'+ response.data.dataNascimento.monthValue +'/'+ response.data.dataNascimento.dayOfMonth).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : null;
				this.modal.dataDelito = response.data.dataDelito ? new Date(response.data.dataDelito.year +'/'+ response.data.dataDelito.monthValue +'/'+ response.data.dataDelito.dayOfMonth).toLocaleDateString() : null;
            this.modal.estudante = response.data.estudante != null ? response.data.estudante == true ? {'value': true, 'desc': 'Sim'} : {'value': false, 'desc': 'Não'} : null;
            this.modal.interesseEstudar = response.data.interesseEstudar != null ? response.data.interesseEstudar == true ? {'value': true, 'desc': 'Sim'} : {'value': false, 'desc': 'Não'} : null;
            this.modal.trabalhando = response.data.trabalhando != null ? response.data.trabalhando == true ? {'value': true, 'desc': 'Sim'} : {'value': false, 'desc': 'Não'} : null;
            this.modal.problemasSaude = response.data.problemasSaude != null ? response.data.problemasSaude == true ? {'value': true, 'desc': 'Sim'} : {'value': false, 'desc': 'Não'} : null;
            this.modal.deficiente = response.data.deficiente != null ? response.data.deficiente == true ? {'value': true, 'desc': 'Sim'} : {'value': false, 'desc': 'Não'} : null;
            this.modal.participaServicoCRAS = response.data.participaServicoCRAS != null ? response.data.participaServicoCRAS == true ? {'value': true, 'desc': 'Sim'} : {'value': false, 'desc': 'Não'} : null;
            this.entidadeSelecionada = this.modal.entidade;
            this.modal.cnpjEntidade = this.modal.entidade.cnpj;
            this.pesquisa.nomeEntidade = this.modal.entidade.nome;
            this.tratado.horas = Math.floor(this.modal.totalHoras / 60)
            this.tratado.minutos = this.modal.totalHoras % 60
            this.buscarEntidades(0)
            this.buscarSentencas()

            $('.nav-tabs3 a[href="#dadospessoais"]').tab('show');

            setTimeout(() => {
               $('#modalSentenciado').modal('show')
            }, 100);

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      adicionarSentenciado() {
         this.entidadeSelecionada = null
         this.pesquisa.nomeEntidade = null;
         this.pesquisa.resultadoSentencas = [];
         this.modal = {'id': null, 'idEntidade': null, 'nomeCompleto': null, 'sexo': null, 'identificacao': null, 'tipoDocumento': null, 'raca': null,
            'cep': null, 'endereco': null, 'telefone': null, 'nomeMae': null, 'nomePai': null, 'profissao': null, 'localTrabalho': null, 'grauEscolaridade': null,
            'habilidades': null, 'turnoTrabalho': 'Manhã', 'enderecoTrabalho': null,'descricaoProblema': null, 'deficiencia': null, 'doencasFamilia': null, 'medicamentosContinuos': null,
            'beneficiosRecebidos': null, 'estudante': null, 'interesseEstudar': null, 'trabalhando': null, 
            'problemasSaude': null, 'deficiente': null, 'participaServicoCRAS': null, 'rendaFamiliar': null,
            'numeroResidentesRemuneracao': null, 'numeroCriancasEscola': null, 'numeroResidentesIdosos': null, 'numeroResidentesCriancas': null, 'numeroResidentes': null,
            'dataNascimento': null, 'numeroProcesso': null, 'negligencia': null, 'totalHoras': null, 'localProcesso': null, 'varaOrigem': 'CRIMINAL', 'status': 'Em cumprimento',
            'artigo': null, 'tipoDelito': null, 'dataDelito': null, 'numeroPasta': null, 'encaminhamento': null, 'dataUltMov': null, 'anexos': [], 'horasPendentes': null,
            'entidade': {}, 'cnpjEntidade': null, 'nomeEntidade': null
         },

         this.tratado = {'horas': 0, 'minutos': 0},

         this.modalSentencas = {'id': null, 'idEntidade': null, 'idSentenciado': null, 'data': new Date().toLocaleDateString(), 'horasCumpridas': null, 'descricao': null, 'descricaoFeedback': null,
            'feedback': null, 'anexos': []
         },

         this.buscarEntidades(0)

         $('.nav-tabs3 a[href="#dadospessoais"]').tab('show');

         setTimeout(() => {
            $('#modalSentenciado').modal('show')

            //tourTutorial
            setTimeout(() => {
               if (localStorage.getItem('tour_add_sentenciado') !== 'ok' && window.innerWidth > 1200) {
                  // this.startTour();
               }
            }, 500);
         }, 100);
      },
      salvarSentenciado() {
         if (this.modal.nomeCompleto == null || this.modal.nomeCompleto.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Nome inválido!'
            })

            $('.nav-tabs3 a[href="#dadospessoais"]').tab('show');

            return
         }

         if (this.modal.sexo == null || this.modal.sexo.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Sexo inválido!'
            })

            $('.nav-tabs3 a[href="#dadospessoais"]').tab('show');

            return
         }
         
         if (this.modal.numeroProcesso == null || this.modal.numeroProcesso.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Númedo do processo inválido!'
            })

            $('.nav-tabs3 a[href="#processo"]').tab('show');

            return
         }

         if (this.modal.id == null && (this.tratado.horas == null || this.tratado.minutos == null || 
            this.tratado.horas === '' || this.tratado.minutos === '' ||
            (this.tratado.horas == 0 && this.tratado.minutos == 0))) {
            this.$toast.fire({
               icon: 'error',
               title: 'Total de horas inválido!'
            })

            $('.nav-tabs3 a[href="#processo"]').tab('show');

            return
         }

         if (this.modal.cnpjEntidade == null || this.modal.cnpjEntidade.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Nenhuma entidade selecionada!'
            })

            $('.nav-tabs3 a[href="#entidade"]').tab('show');

            return
         }

         this.modal.estudante = this.modal.estudante != null ? this.modal.estudante.value : null;
         this.modal.interesseEstudar = this.modal.interesseEstudar != null ? this.modal.interesseEstudar.value : null;
         this.modal.trabalhando = this.modal.trabalhando != null ? this.modal.trabalhando.value : null;
         this.modal.problemasSaude = this.modal.problemasSaude != null ? this.modal.problemasSaude.value : null;
         this.modal.deficiente = this.modal.deficiente != null ? this.modal.deficiente.value : null;
         this.modal.participaServicoCRAS = this.modal.participaServicoCRAS != null ? this.modal.participaServicoCRAS.value : null;
         this.modal.totalHoras = (parseInt(this.tratado.horas) * 60) + parseInt(this.tratado.minutos)
         this.modal.dataNascimento = this.modal.dataNascimento == '' ? null : this.modal.dataNascimento;
         this.modal.encaminhamento = this.modal.encaminhamento == '' ? null : this.modal.encaminhamento;
         this.modal.dataDelito = this.modal.dataDelito == '' ? null : this.modal.dataDelito;

         let ref = this;
         
         let anexos = [];
         let dataForm = new FormData();
         
         for (let file of this.modal.anexos) {
            if (file.name == null && file.caminho != null) {
               anexos.push(file)
            } else {
               dataForm.append('file', file, file.name.replace(/[^\w\s.]/gi, ''));
            }
         }
         
         this.modal.anexos = anexos;
         dataForm.append('info', JSON.stringify(this.modal));
         
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'post',
            url: this.urlRest +'sentenciado/saveSentenciado',
            headers: {
					'Content-Type': 'multipart/form-data'
            },
				data: dataForm

         }).then(function () {
				$('#modalSentenciado').modal('hide')
         
            ref.buscarSentenciados(0)

            ref.$toast.fire({
               icon: 'success',
               title: 'Sentenciado salvo!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Data de nascimento inválida!'
                  });
               } else if (error.response.status == 403) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Documento de Indenficação inválido!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      deletarSentenciado(sentenciado) {
         let ref = this;

         Swal.fire({
            icon: 'warning',
            title: 'Excluir sentenciado',
            confirmButtonText: 'Confirmar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar'

         }).then((result) => {
            if (result.isConfirmed) {
               ref.$store.dispatch('alternarTelaCarregamento', true)

               ref.$axios({
                  method: 'post',
                  url: ref.urlRest +'sentenciado/deleteSentenciado',
                  params:{
                     id: sentenciado.id
                  }
               }).then(function () {
                  ref.buscarSentenciados(0)

                  ref.$toast.fire({
                     icon: 'success',
                     title: 'Sentenciado excluído!'
                  })
               }).catch(function (error) {
                  if (error.response != undefined) {
                     if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                           icon: 'warning',
                           title: 'Sessão expirada!'
                        });
                     } else {
                        ref.$toast.fire({
                           icon: 'error',
                           title: 'Erro: ' + error.response.status
                        })
                     }
                  } else {
                     ref.$toast.fire({
                        icon: 'error',
                        title: error
                     })
                  }
               }).finally(() => {
                  ref.$store.dispatch('alternarTelaCarregamento', false)
               })
            }
         });
      },

      buscarCEP() {
         let ref = this;

         this.$store.dispatch('buscarCEP', this.modal.cep).then(function(data) {
            ref.modal.endereco = data;
			})
      },
      buscarEntidade() {
         let ref = this;
         
         if (this.entidadeSelecionada == null) {
            ref.$toast.fire({
               icon: 'error',
               title: 'Selecione uma entidade'
            });

            return
         }
         
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'entidades/getEntidade',
            params: {
               nome: this.entidadeSelecionada.nome
            }

         }).then(response => {
            if (response.data != null) {
               ref.modalConfig.entidade = true;
               ref.modal.nomeEntidade = ref.entidadeSelecionada.nome;
               ref.modal.idEntidade = ref.entidadeSelecionada.id
               ref.modal.cnpjEntidade = response.data.cnpj;
            }
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Entidade não encontrada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      searchAllEntidades() {
         let ref = this;

         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'entidades/searchAllEntidades',

         }).then(response => {
				this.listaEntidades = response.data

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      buscarEntidades(pagina2) {
         let ref = this;
         this.pagina2 = pagina2 == null ? ++this.pagina2 : pagina2
         
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'entidades/searchEntidades',
            params: {
               tipo: 'Nome',
               valor: this.pesquisa.nomeEntidade,
               page: this.pagina2
            }
         }).then(response => {
            if (this.pagina2 == 0) {
               this.pesquisa.resultadoEntidades = []
            }

            this.totalPagina2 = response.data.length

            response.data.forEach(p => {
               this.pesquisa.resultadoEntidades.push(p)
            });

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      vincularEntidade(entidade) {
         if (entidade.id == this.modal.idEntidade) {
            return
         }

         this.modal.idEntidade = entidade.id;
         this.modal.cnpjEntidade = entidade.cnpj;
         this.modal.nomeEntidade = entidade.nome;
      },

      adicionarSentenca() {
         this.modalSentencas = {'id': null, 'idEntidade': null, 'idSentenciado': null, 'data': new Date().toLocaleDateString(), 'horasCumpridas': null, 'descricao': null, 'descricaoFeedback': null, 'feedback': null, 'anexos': []}
         this.tratado2 = {'horas': 0, 'minutos': 0},
         $('#modalSentenciado').modal('hide')
         $('#modalSentencas').modal('show')
      },
      salvarSentenca() {
         let totalMinutos = (parseInt(this.tratado2.horas) * 60) + parseInt(this.tratado2.minutos);

         if (this.tratado2.horas == null || this.tratado2.minutos == null || 
            this.tratado2.horas === '' || this.tratado2.minutos === '' ||
            (this.tratado2.horas == 0 && this.tratado2.minutos == 0)) {
            this.$toast.fire({
               icon: 'error',
               title: 'Horas inválidas!'
            })

            return
         }
         
         if (totalMinutos <= 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Hora(s) e minuto(s) devem ser maior que zero!'
            })

            return
         }

         if (this.modalSentencas.data == null || this.modalSentencas.data.trim().length < 8) {
            this.$toast.fire({
               icon: 'error',
               title: 'Data inválida!'
            })

            return
         }

         const [day, month, year] = this.modalSentencas.data.split('/')
         const inputDate = new Date(year, month - 1, day)
         if (inputDate > new Date()) {
            this.$toast.fire({
               icon: 'error',
               title: 'Não é permitido datas futuras!'
            })
            return
         }

         if (totalMinutos > this.modal.horasPendentes) {
            this.$toast.fire({
               icon: 'error', 
               title: 'Hora(s) excedidas!'
            })
            return
         }

         if (totalMinutos > this.modal.horasPendentes) {
            this.$toast.fire({
               icon: 'error',
               title: 'Hora(s) excedidas!'
            })

            return
         }

         this.modalSentencas.idEntidade = this.modal.idEntidade;
         this.modalSentencas.idSentenciado = this.modal.id;
         this.modalSentencas.horasCumpridas = (parseInt(this.tratado2.horas) * 60) + parseInt(this.tratado2.minutos)

         let ref = this;

         let anexos = [];
         let dataForm = new FormData();
         
         for (let file of this.modalSentencas.anexos) {
            if (file.name == null && file.caminho != null) {
               anexos.push(file)
            } else {
               dataForm.append('file', file, file.name.replace(/[^\w\s.]/gi, ''));
            }
         }
         
         this.modalSentencas.anexos = anexos;
         dataForm.append('info', JSON.stringify(this.modalSentencas));

			this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'post',
            url: this.urlRest +'servicos/saveServico',
            headers: {
					'Content-Type': 'multipart/form-data'
            },
				data: dataForm

         }).then(function () {
            $('#modalSentencas').modal('hide')
            ref.modal.horasPendentes = ref.modal.horasPendentes - ref.modalSentencas.horasCumpridas;
            ref.modal.status = 'Em cumprimento'
            $('#modalSentenciado').modal('show')

            ref.buscarSentencas()
            
            ref.$toast.fire({
               icon: 'success',
               title: 'Servico salvo!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Nenhum processo encontrado!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      buscarSentencas() {
         let ref = this;

         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'servicos/searchServicos',
            params: {
               id: this.modal.id,
            }

         }).then(response => {
				this.pesquisa.resultadoSentencas = response.data

            if (this.pesquisa.resultadoSentencas && this.pesquisa.resultadoSentencas.length > 0) {
               this.pesquisa.resultadoSentencas.forEach(item => {
                  if (item.data) {
                     item.data = new Date(item.data.year + '/' + item.data.monthValue + '/' + item.data.dayOfMonth).toLocaleDateString()
                  } else {
                     item.data = null
                  }
               })
            }

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      deletarSentenca(sentenca, index) {
         let ref = this;

         Swal.fire({
            icon: 'warning',
            title: 'Excluir registro de horário?',
            confirmButtonText: 'Confirmar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar'

         }).then((result) => {
            if (result.isConfirmed) {
               ref.$store.dispatch('alternarTelaCarregamento', true)
               
               ref.$axios({
                  method: 'post',
                  url: ref.urlRest +'servicos/deleteServico',
                  params:{
                     id: sentenca.id
                  }
               }).then(function () {
                  ref.modal.horasPendentes = ref.modal.horasPendentes + ref.pesquisa.resultadoSentencas[index].horasCumpridas;
                  ref.pesquisa.resultadoSentencas.splice(index, 1)

                  ref.$toast.fire({
                     icon: 'success',
                     title: 'Relatório excluído!'
                  })
               }).catch(function (error) {
                  if (error.response != undefined) {
                     if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                           icon: 'warning',
                           title: 'Sessão expirada!'
                        });
                     } else {
                        ref.$toast.fire({
                           icon: 'error',
                           title: 'Erro: ' + error.response.status
                        })
                     }
                  } else {
                     ref.$toast.fire({
                        icon: 'error',
                        title: error
                     })
                  }
               }).finally(() => {
                  ref.$store.dispatch('alternarTelaCarregamento', false)
               })
            }
         });
      },

      showFiles() {
         if ((this.$refs.files.files.length + this.modal.anexos.length) > 100) {
            Swal.fire({
               icon: 'error',
               title: 'Limite atingido',
               text: 'Máximo de anexos excedido (100).'
            });

            this.$refs.files.value = "";

            return
         }

         for (let file of this.$refs.files.files) {
            if (file.size < 10485760) {
               this.modal.anexos.push(file)
            } else {
               Swal.fire({
                  icon: 'error',
                  title: 'Tamanho excedido',
                  text: 'Arquivo excede 10MB'
               });

               break
            }
         }

         setTimeout(() => {
            this.$refs.files.value = "";
         }, 250);
      },
      showFiles2() {
         if ((this.$refs.files2.files.length + this.modalSentencas.anexos.length) > 1) {
            Swal.fire({
               icon: 'error',
               title: 'Limite atingido',
               text: 'Máximo de anexos excedido (1).'
            });

            this.$refs.files2.value = "";

            return
         }

         for (let file of this.$refs.files2.files) {
            if (file.size < 10485760) {
               this.modalSentencas.anexos.push(file)
            } else {
               Swal.fire({
                  icon: 'error',
                  title: 'Tamanho excedido',
                  text: 'Arquivo excede 10MB'
               });

               break
            }
         }

         setTimeout(() => {
            this.$refs.files2.value = "";
         }, 250);
      },
      removeFile(index, tipo) {
         if (tipo == 'arquivos') {
            this.modal.anexos.splice(index, 1)
         } else if (tipo == 'relatorios') {
            this.modalSentencas.anexos.splice(index, 1)
         }
      },
      visualizarFile(file) {
         const link = document.createElement('a');
         link.href = file.caminho;
         link.target = '_blank';
         link.rel = 'noopener noreferrer';
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      },
      atualizarGraficoPie() {
			this.chartPie.series[0].data = [];
         this.chartPie.series[0].data.push({'name': 'Horas já cumpridas', 'y': this.dadosPdf.horasCumpridas})
         this.chartPie.series[0].data.push({'name': 'Horas pendentes', 'y': this.dadosPdf.horasPendentes})
		},
      downloadPdf() {
         vuePDF(this.$refs.html2Pdf, {
            margin: [0, 0, 0, 0],
            filename: this.dadosPdf.nomeCompleto + '.pdf',
            image: { type: 'jpeg', quality: 1 },
            pagebreak: { avoid: 'tr' },
            html2canvas: { 
               letterRendering: true, 
               useCORS: true, 
               dpi: 300,
               scale: 1,
               windowWidth: 794,
               windowHeight: 1123
            },
            jsPDF: { 
               unit: 'mm', 
               format: 'a4', 
               orientation: 'portrait', 
               hotfixes: ['px_scaling'],
               compress: true
            }
         })
      },
      imprimirRelatorio(id) {
         let ref = this
         ref.dadosPdf = {'averageFeedback': 0, 'dataNascimento': {'dayOfMonth': 0, 'monthValue': 0, 'year': 0}, 'dataUltMov': {'dayOfMonth': 0, 'monthValue': 0, 'year': 0}, 'dataSentenca': {'dayOfMonth': 0, 'monthValue': 0, 'year': 0}},

         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'sentenciado/relatorioSentenciado',
            params: {
               id: id
            }
         }).then(response => {
				ref.dadosPdf = response.data
            this.atualizarGraficoPie()
            this.downloadPdf()

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      abrirRelatorioGeral() {
         this.pesquisa.resultadoRelatorioGeral = {'dados':[]}
         this.modalRelatorio = {'varaOrigem': 'Todos', 'sexo': 'Todos', 'filtro': 'Todos'},
         $('#modalRelatorioGeral').modal('show')
      },
      async processarPdfsEmLotes(dadosRelatorioCompleto) {
         let ref = this;
         const TAMANHO_LOTE = 250;
         const todosOsDados = dadosRelatorioCompleto.dados;
         const totalLotes = Math.ceil(todosOsDados.length / TAMANHO_LOTE);

         for (let i = 0; i < totalLotes; i++) {
            const inicio = i * TAMANHO_LOTE;
            const fim = inicio + TAMANHO_LOTE;
            const loteDados = todosOsDados.slice(inicio, fim);

            ref.pesquisa.resultadoRelatorioGeral = {
               ...dadosRelatorioCompleto, 
               dados: loteDados 
            };

            await ref.$nextTick();

            let nomeArquivo = totalLotes > 1 
                ? 'Relatório geral ' + new Date().toLocaleDateString('pt-BR') + ' - Parte ' + (i + 1) + '.pdf' 
                : 'Relatório geral ' + new Date().toLocaleDateString('pt-BR') + '.pdf';

            await vuePDF(ref.$refs.html2PdfGeral, {
               margin: [15, 12, 15, 12],
               filename: nomeArquivo,
               image: { type: 'jpeg', quality: 0.98 },
               pagebreak: { mode: ['avoid-all', 'css', 'legacy'], avoid: '.pdf-sentenciado-card' },
               html2canvas: { letterRendering: true, useCORS: true, dpi: 150, scale: 1 },
               jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', hotfixes: ['px_scaling'], compress: true }
            });
         }
         
         ref.pesquisa.resultadoRelatorioGeral = {'dados':[]};
      },
      gerarRelatorioGeral() {
         let ref = this;
         this.pesquisa.resultadoRelatorioGeral = {'dados':[]}

         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'sentenciado/relatorioPrestadores',
            params: {
               sexo: this.modalRelatorio.sexo == 'Todos' ? null : this.modalRelatorio.sexo,
               varaOrigem : this.modalRelatorio.varaOrigem == 'Todos' ? null : this.modalRelatorio.varaOrigem,
               filtro: this.modalRelatorio.filtro == 'Todos' ? null : this.modalRelatorio.filtro
            }
         }).then(async response => {
				let dadosRelatorioCompleto = response.data;
            
            if (dadosRelatorioCompleto.dados && dadosRelatorioCompleto.dados.length > 0) {
               await ref.processarPdfsEmLotes(dadosRelatorioCompleto);
            } else {
               ref.$toast.fire({
                  icon: 'warning',
                  title: 'Nenhum registro encontrado!'
               });
            }

            $('#modalRelatorioGeral').modal('hide')

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      formatarMinutosParaHoras(minutos) {
         const horas = Math.floor(minutos / 60);
         const minutosRestantes = minutos % 60;
         return `${String(horas).padStart(2, '0')}:${String(minutosRestantes).padStart(2, '0')}`;
      },
      formatarDataObjeto(data) {
         if (!data) {
            return 'Não informado';
         }

         const { dayOfMonth, monthValue, year } = data;

         if ([dayOfMonth, monthValue, year].some(valor => valor === null || valor === undefined)) {
            return 'Não informado';
         }

         const dia = String(dayOfMonth).padStart(2, '0');
         const mes = String(monthValue).padStart(2, '0');

         if (Number.isNaN(Number(year)) || Number.isNaN(Number(dayOfMonth)) || Number.isNaN(Number(monthValue))) {
            return 'Não informado';
         }

         return `${dia}/${mes}/${year}`;
      },
      mudarVisao() {
         this.modoVisao = this.modoVisao == 'visaoSimples' ? 'visaoDetalhada' : 'visaoSimples'
         localStorage.setItem('modoVisao', this.modoVisao)
      },
      startTour() {
			const steps = [];

			steps.push({
            element: '#add_sentenciado_step1',
            intro: 'Navegue pelas abas para preencher todos os dados necessários.'
         });

         steps.push({
            element: '#add_sentenciado_step2',
            intro: 'Preencha todos os campos que estão sinalizados como obrigatórios.'
         });

         steps.push({
            element: '#add_sentenciado_step3',
            intro: 'Não se esqueça de clicar em salvar para salvar os dados.'
         });

			// Inicia o tour com os steps filtrados
			this.$intro().setOptions({
				steps
			}).start();

			localStorage.setItem('tour_add_sentenciado', 'ok')
		},
      startTour2() {
			const steps = [];

         steps.push({
            element: '#card_sentenciado_step0',
            intro: 'Vamos ver algumas informações sobre o card do sentenciado.'
         });

			steps.push({
            element: '#card_sentenciado_step1',
            intro: 'Neste card, você visualiza o nome do sentenciado e a entidade à qual ele está vinculado.'
         });

            steps.push({
            element: '#card_sentenciado_step2',
            intro: 'Também estão disponíveis o documento do sentenciado, número do processo e sexo.'
         });

            steps.push({
            element: '#card_sentenciado_step3',
            intro: 'O status é atualizado automaticamente com base no último registro de horas. Após 30 dias sem novos registros, o status muda para "Descumprimento".'
         });

            steps.push({
            element: '#card_sentenciado_step4',
            intro: 'Acompanhe o total de horas já cumpridas, as pendentes e o progresso visualizado em gráfico.'
         });

            steps.push({
            element: '#card_sentenciado_step5',
            intro: 'Veja aqui o total de horas que o sentenciado deve cumprir.'
         });

            steps.push({
            element: '#card_sentenciado_step6',
            intro: 'A porcentagem exibida representa o quanto do total de horas já foi cumprido.'
         });

            steps.push({
            element: '#card_sentenciado_step7',
            intro: 'Use os botões disponíveis para acessar mais opções de gerenciamento do sentenciado.'
         });

			// Inicia o tour com os steps filtrados
			this.$intro().setOptions({
				steps
			}).start();

			localStorage.setItem('tour_card_sentenciado', 'ok')
		}
   },
   mounted() {
      this.buscarSentenciados(0)
   }
}

</script>

<style scoped>
input[type="file"] {
   position: absolute;
   top: 0;
   right: 0;
   min-width: 100%;
   min-height: 100%;
   font-size: 100px;
   text-align: right;
   filter: alpha(opacity=0);
   opacity: 0;
   outline: none;
   background: white;
   cursor: inherit;
   display: block;
}

.bg-success {
   background-color: var(--primary-color) !important;
}

.bg-warning {
   background-color: #7979794f !important;
}

.text-center-no-shadow {
   box-shadow: none !important;
   display: flex;
   justify-content: center;
   align-items: center;
}

/* Estilos do PDF - Layout Profissional A4 */
.pdf-container {
   width: 210mm;
   height: 295mm;
   padding: 12mm 18mm;
   font-family: 'Arial', 'Helvetica', sans-serif;
   color: #000000;
   background: #ffffff;
   box-sizing: border-box;
   display: flex;
   flex-direction: column;
   overflow: hidden;
}

.pdf-header {
   margin-bottom: 8mm;
   flex-shrink: 0;
}

.pdf-title {
   font-size: 16pt;
   font-weight: 700;
   letter-spacing: 1.5px;
   text-align: center;
   margin: 0 0 6mm 0;
   color: #000000;
   text-transform: uppercase;
}

.pdf-divider {
   height: 1px;
   background: #000000;
   margin: 0;
}

.pdf-section {
   margin-bottom: 7mm;
   page-break-inside: avoid;
   flex-shrink: 0;
}

.pdf-section-title {
   font-size: 11pt;
   font-weight: 700;
   margin: 0 0 4mm 0;
   padding-bottom: 1.5mm;
   border-bottom: 1px solid #000000;
   text-transform: uppercase;
   letter-spacing: 0.5px;
   color: #000000;
}

.pdf-grid {
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 3mm 6mm;
   margin-top: 3mm;
}

.pdf-grid-item {
   display: flex;
   flex-direction: column;
   gap: 0.8mm;
}

.pdf-grid-item.pdf-full-width {
   grid-column: 1 / -1;
}

.pdf-label {
   font-size: 8pt;
   font-weight: 600;
   color: #000000;
   text-transform: uppercase;
   letter-spacing: 0.3px;
   line-height: 1.2;
}

.pdf-value {
   font-size: 9pt;
   color: #000000;
   line-height: 1.3;
}

.pdf-section-stats {
   margin-bottom: 0;
   flex: 1;
   display: flex;
   flex-direction: column;
   min-height: 0;
}

.pdf-stats-container {
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 6mm;
   margin-top: 3mm;
   align-items: center;
   flex: 1;
   min-height: 0;
}

.pdf-stats-data {
   display: flex;
   flex-direction: column;
   gap: 4mm;
   justify-content: center;
}

.pdf-stat-item {
   display: flex;
   flex-direction: column;
   gap: 1.5mm;
   padding-bottom: 3mm;
   border-bottom: 1px solid #e0e0e0;
}

.pdf-stat-item:last-child {
   border-bottom: none;
}

.pdf-stat-item.pdf-stat-percentage {
   border-top: 2px solid #000000;
   padding-top: 3mm;
   margin-top: 2mm;
}

.pdf-stat-label {
   font-size: 8pt;
   font-weight: 600;
   color: #000000;
   text-transform: uppercase;
   letter-spacing: 0.3px;
}

.pdf-stat-value {
   font-size: 13pt;
   font-weight: 700;
   color: #000000;
   letter-spacing: 0.5px;
}

.pdf-chart-wrapper {
   width: 100%;
   height: 100%;
   max-height: 70mm;
   display: flex;
   align-items: center;
   justify-content: center;
   flex-shrink: 0;
}

.pdf-chart {
   width: 100%;
   height: 100%;
}

.badge {
   border: 1px solid transparent !important;
}

/* Estilos do Relatório Geral */
.pdf-relatorio-geral {
   font-family: 'Arial', sans-serif;
   width: 100%;
   max-width: 210mm;
   margin: 0 auto;
   padding: 0;
   background: #ffffff;
   color: #000000;
   box-sizing: border-box;
}

.pdf-relatorio-header {
   margin-bottom: 6mm;
   padding-bottom: 4mm;
   border-bottom: 2px solid #000000;
   page-break-after: avoid;
}

.pdf-relatorio-title {
   font-size: 16pt;
   font-weight: 700;
   margin: 0 0 4mm 0;
   color: #000000;
   letter-spacing: 0.5px;
   text-transform: uppercase;
}

.pdf-relatorio-meta {
   display: flex;
   flex-direction: column;
   gap: 2mm;
}

.pdf-relatorio-stats {
   display: flex;
   flex-wrap: wrap;
   gap: 2mm;
}

.pdf-stat-badge {
   font-size: 7pt;
   font-weight: 600;
   padding: 1.5mm 3mm;
   background: #f5f5f5;
   border: 1px solid #d0d0d0;
   border-radius: 2px;
   color: #000000;
   white-space: nowrap;
}

.pdf-relatorio-filters {
   display: flex;
   flex-wrap: wrap;
   gap: 3mm;
   font-size: 7pt;
   color: #666666;
}

.pdf-filter-item {
   padding: 0.5mm 0;
}

.pdf-relatorio-content {
   margin-top: 5mm;
}

.pdf-sentenciado-card {
   page-break-inside: avoid;
   break-inside: avoid;
   margin-bottom: 4mm;
   border: 1px solid #e0e0e0;
   border-radius: 2px;
   background: #ffffff;
   overflow: hidden;
}

.pdf-sentenciado-header {
   display: flex;
   align-items: center;
   gap: 2mm;
   padding: 2.5mm 3mm;
   background: #f8f8f8;
   border-bottom: 1px solid #e0e0e0;
}

.pdf-sentenciado-number {
   font-size: 9pt;
   font-weight: 700;
   color: #666666;
   min-width: 18px;
   text-align: center;
}

.pdf-sentenciado-name {
   flex: 1;
   font-size: 10pt;
   font-weight: 600;
   color: #000000;
   line-height: 1.3;
}

.pdf-sentenciado-status {
   font-size: 7pt;
   font-weight: 600;
   padding: 1.5mm 3mm;
   border-radius: 2px;
   text-transform: uppercase;
   letter-spacing: 0.3px;
   white-space: nowrap;
}

.pdf-sentenciado-status.status-em-cumprimento {
   background: #e3f2fd;
   color: #1976d2;
   border: 1px solid #90caf9;
}

.pdf-sentenciado-status.status-descumprimento {
   background: #ffebee;
   color: #c62828;
   border: 1px solid #ef9a9a;
}

.pdf-sentenciado-status.status-arquivado {
   background: #f3e5f5;
   color: #7b1fa2;
   border: 1px solid #ce93d8;
}

.pdf-sentenciado-status.status-finalizado {
   background: #e8f5e9;
   color: #2e7d32;
   border: 1px solid #a5d6a7;
}

.pdf-sentenciado-body {
   padding: 3mm;
}

.pdf-sentenciado-grid {
   display: grid;
   grid-template-columns: repeat(2, 1fr);
   gap: 2mm 4mm;
}

@media (max-width: 150mm) {
   .pdf-sentenciado-grid {
      grid-template-columns: 1fr;
      gap: 3mm;
   }
}

.pdf-sentenciado-field {
   display: flex;
   flex-direction: column;
   gap: 0.5mm;
}

.pdf-field-label {
   font-size: 6.5pt;
   font-weight: 600;
   color: #666666;
   text-transform: uppercase;
   letter-spacing: 0.2px;
   line-height: 1.2;
}

.pdf-field-value {
   font-size: 8.5pt;
   color: #000000;
   line-height: 1.3;
   word-break: break-word;
}

.pdf-field-value.pdf-field-hours {
   font-weight: 600;
   font-family: 'Courier New', monospace;
   color: #000000;
}

/* Ajustes para impressão A4 */
@media print {
   .pdf-relatorio-geral {
      padding: 15mm 12mm;
   }
   
   .pdf-sentenciado-card {
      page-break-inside: avoid;
      break-inside: avoid;
   }
}

</style>